import { useEffect, useState } from "react";
import api from "../api/api";

function Members() {
  const [members, setMembers] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", phone: "" });

  const fetchMembers = async () => {
    const res = await api.get("/members/");
    setMembers(res.data);
  };

  useEffect(() => { fetchMembers(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await api.post("/members", form);
    fetchMembers();
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Members</h2>

      <form onSubmit={handleSubmit}>
        <input placeholder="Name" onChange={e => setForm({ ...form, name: e.target.value })} required />
        <input placeholder="Email" onChange={e => setForm({ ...form, email: e.target.value })} required />
        <input placeholder="Phone" onChange={e => setForm({ ...form, phone: e.target.value })} required />
        <button type="submit">Add Member</button>
      </form>

      <ul>
        {members.map(m => (
          <li key={m._id}>{m.name} — {m.email}</li>
        ))}
      </ul>
    </div>
  );
}

export default Members;